// CreateIndex.js — 本文 h2/h3 から目次生成（ScrollTrigger でアクティブ連動）

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const CONFIG = {
  navWrapSelector: '.js-single-nav',
  contentSelector: '.c-single__content',
  minHeadings: 3,
  indexTitle: 'Index',
  indexClass: 'c-index',
  titleClass: 'c-index__title',
  listClass: 'c-index__list',
  itemClass: 'c-index__item',
  linkClass: 'c-index__link',
  numberClass: 'c-index__number',
  childListClass: 'c-index__child',
  childItemClass: 'c-index__child-item',
  childLinkClass: 'c-index__child-link',
  activeLinkClass: 'is-active',
  triggerStart: 'top center',
  triggerEnd: 'bottom center',
};

function createIndex() {
  const navWrap = document.querySelector(CONFIG.navWrapSelector);
  if (!navWrap) return;

  // const isColumn = Boolean(navWrap.closest('.p-column'));

  const heads = document.querySelectorAll(`${CONFIG.contentSelector} :is(h2, h3)`);
  const h2Count = [...heads].filter((head) => head.tagName === 'H2').length;
  if (h2Count < CONFIG.minHeadings) return;

  const indexEl = document.createElement('div');
  indexEl.classList.add(CONFIG.indexClass);

  const titleEl = document.createElement('p');
  titleEl.classList.add(CONFIG.titleClass);
  titleEl.textContent = CONFIG.indexTitle;
  indexEl.appendChild(titleEl);

  const ul = document.createElement('ul');
  ul.classList.add(CONFIG.listClass);

  let childList = null;
  let parentIndex = 0;
  const linkedHeads = [];

  heads.forEach((head, i) => {
    if (!head.id) {
      head.id = `section-${i + 1}`;
    }

    if (head.tagName === 'H2') {
      parentIndex += 1;
      childList = null;

      const li = document.createElement('li');
      li.classList.add(CONFIG.itemClass);

      const a = document.createElement('a');
      a.classList.add(CONFIG.linkClass);
      a.href = `#${head.id}`;

      const number = document.createElement('span');
      number.classList.add(CONFIG.numberClass);
      number.setAttribute('lang', 'en');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = `${String(parentIndex).padStart(2, '0')}.`;

      a.appendChild(number);
      a.appendChild(document.createTextNode(head.textContent));
      li.appendChild(a);
      ul.appendChild(li);
      linkedHeads.push(head);
      return;
    }

    // if (head.tagName !== 'H3' || !isColumn) return;

    // 親 h2 が無い h3 は出さない
    // 目次はh2までとのことでコメントアウトしてます
    // const parentItem = ul.lastElementChild;
    // if (!parentItem) return;

    // if (!childList) {
    //   childList = document.createElement('ul');
    //   childList.classList.add(CONFIG.childListClass);
    //   parentItem.appendChild(childList);
    // }

    // const childItem = document.createElement('li');
    // childItem.classList.add(CONFIG.childItemClass);

    // const childLink = document.createElement('a');
    // childLink.classList.add(CONFIG.childLinkClass);
    // childLink.href = `#${head.id}`;
    // childLink.textContent = head.textContent;

    // childItem.appendChild(childLink);
    // childList.appendChild(childItem);
    // linkedHeads.push(head);
  });

  indexEl.appendChild(ul);
  navWrap.appendChild(indexEl);

  const links = indexEl.querySelectorAll(`.${CONFIG.linkClass}, .${CONFIG.childLinkClass}`);

  linkedHeads.forEach((head, i) => {
    ScrollTrigger.create({
      trigger: head,
      start: CONFIG.triggerStart,
      end: CONFIG.triggerEnd,
      onEnter: () => setActiveLink(i, links),
      onEnterBack: () => setActiveLink(i, links),
    });
  });
}

function setActiveLink(activeIndex, links) {
  links.forEach((link, i) => {
    link.classList.toggle(CONFIG.activeLinkClass, i === activeIndex);
  });
}

export { createIndex };
